import { Outlet, createRootRoute } from "@tanstack/react-router";
import { SmoothScroll } from "~/components/SmoothScroll";
import { Header } from "~/components/chrome/Header";
import { Footer } from "~/components/chrome/Footer";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <SmoothScroll />
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Header />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
